var map = {
	"./00.mp3": "df8b",
	"./01.mp3": "3516",
	"./02.mp3": "b1d5",
	"./03.mp3": "fa73",
	"./04.mp3": "50f9",
	"./05.mp3": "efc2",
	"./06.mp3": "55f1",
	"./07.mp3": "63b1",
	"./08.mp3": "c59b",
	"./09.mp3": "a138",
	"./10.mp3": "5bd6",
	"./11.mp3": "e4cb",
	"./12.mp3": "ba27",
	"./13.mp3": "55bc",
	"./14.mp3": "f284",
	"./M_Brilliant.mp3": "d79e",
	"./M_Excellent.mp3": "fe26",
	"./M_Fantastic.mp3": "58ce",
	"./M_Great.mp3": "ef3f",
	"./M_Perfect.mp3": "e3db9",
	"./M_Think again.mp3": "f40e",
	"./M_Try again.mp3": "bff9",
	"./M_Very good.mp3": "f351",
	"./M_Well done.mp3": "522b",
	"./M_Work harder.mp3": "c5b6",
	"./click.mp3": "a627",
	"./false.mp3": "7bb1",
	"./true.mp3": "b476"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2fb3";